import { loadShareSync} from "@module-federation/runtime";
export const __synthetic = loadShareSync('react/jsx-runtime')();
